/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Field, useField, useFormikContext } from "formik";
import React, { useEffect } from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { useStrings } from "../../localization/localizationHelpers";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { EmbeddedOtherTextField } from "../EmbeddedOtherTextField/EmbeddedOtherTextField";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps } from "../FieldHeader";
import { useSetFieldTouched } from "../useSetFieldTouched";
import * as styles from "./CustomRadioOptionsField.module.css";

export type CustomRadioOption = Readonly<{
  value: string;
  label: string;
}>;

export type CustomRadioOptionsFieldProps = Readonly<{
  options: CustomRadioOption[];

  name: string;
  parentChecked?: boolean;
  isOtherChecked?: boolean;
  listAsColumn?: boolean;
  isSaving?: boolean;
  disabled?: boolean;
  setChildInputForm?: React.Dispatch<React.SetStateAction<boolean | undefined>>;
}> &
  FieldHeaderProps;

export const CustomRadioOptionsField = (props: CustomRadioOptionsFieldProps) => {
  const [other] = useStrings("other");

  const { name, options, listAsColumn, isSaving, disabled, parentChecked } = props;
  const [field] = useField(props);
  useSetFieldTouched(field.name);
  const { setFieldValue } = useFormikContext();

  const matchChildInputNameValuesMap = new Map([["gameEngine", "engineOther"]]);

  const embeddedInputName = matchChildInputNameValuesMap.get(field.name);

  const [otherInputField] = useField({
    name: embeddedInputName ?? "",
  });

  useEffect(() => {
    if (field.value !== "Other" && field.value !== "" && embeddedInputName) {
      if (otherInputField.value !== "") {
        setFieldValue(embeddedInputName, "");
      }
    }
  }, [embeddedInputName, otherInputField.value, field.value, setFieldValue]);

  return (
    <Row className={commonStyles.container}>
      <Column>
        <FieldHeader {...props} />
        <div role="group" aria-labelledby="radio-options-group">
          <div className={listAsColumn ? undefined : styles.optionsGroups}>
            {options.map(option => (
              <label
                key={`radio-option-${option.value}`}
                className={listAsColumn ? styles.optionAsColumn : styles.option}
              >
                <Field
                  type="radio"
                  name={name}
                  value={option.value}
                  data-testid={name}
                  on
                  disabled={isSaving || disabled || parentChecked === false}
                />
                {option.label}
                {option.label === other && embeddedInputName && (
                  <EmbeddedOtherTextField
                    name={embeddedInputName}
                    isRequiredField={field.value === "Other"}
                    isSaving={isSaving || field.value !== "Other"}
                    parentChecked={field.value === "Other"}
                  />
                )}
              </label>
            ))}
          </div>
        </div>
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
